import styled from 'styled-components';
import { renderStyledElementStyles } from '../../../../helpers';

export const StyledCard = styled.li`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;

  ${({ theme }) =>
    renderStyledElementStyles(
      theme,
      theme.module.optionsVStyles?.elements?.card,
    )}
`;
